








































import getVSelectOptionByValue from 'piramis-js-utils/lib/getVSelectOptionByValue'
import { extend, ValidationProvider } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import vSelect from 'vue-select'

import { SelectOption } from '../../../logic/types'
import ConfigField from '../../ConfigField/ConfigField.vue'

type GetawayRequiredField = {
  type: string
  label?: string
  format?: string
  // eslint-disable-next-line id-blacklist
  values?: Record<string, any>
}

@Component({
  components: {
    ValidationProvider,
    ConfigField,
    vSelect,
  },
  methods: {
    getVSelectOptionByValue,
  },
})
export default class GetawayRequiredFieldView extends Vue {
  @Prop() readonly value!: any

  @Prop() readonly field!: GetawayRequiredField

  @Prop() readonly name!: string

  get valueComputed(): any {
    return this.value
  }

  set valueComputed(newValue: any) {
    this.$emit('input', newValue)
  }

  private options: Array<SelectOption> = []

  get selectValueComputed(): SelectOption {
    return this.value
  }

  set selectValueComputed(option: SelectOption) {
    this.$emit('input', option || null)
  }

  public created(): void {
    extend('required', required)

    if (this.field.values !== undefined) {
      const optionValues: any = this.field.values
      this.options = Object.keys(optionValues).map((optionKey) => ({ label: optionValues[optionKey], value: optionKey }))
    }
  }
}
